import React, {useState, useEffect, useRef, useContext} from 'react';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { InputNumber } from 'primereact/inputnumber';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { AuthContext } from "../../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { MultiSelect } from 'primereact/multiselect';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { Button } from 'primereact/button';
import CustomDropdown from '../../../custom/customDropdown';
import { Calendar } from 'primereact/calendar';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { FileUpload } from 'primereact/fileupload';
import handlePrintInvoice from '../../Fakture/IzlazneFakture/faktureStrane/fakturaStampa';
import { Badge } from 'primereact/badge';
import VozacTroskoviDialog from './VozacTroskoviDialog';

const Troskovi = ({ vozacTroskovi, osveziVozacTroskove }) => {
  const { t } = useTranslation();

        const toast = useRef(null);
        const formRef = useRef(null);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const role = useSelector(state => state.user_role)
        const trip = useSelector(state => state.trip)
        const user = useSelector(state => state.user)
        const [idExpence, setIdExpence] = useState(null);
        const [valuteDB, setValutaDB] = useState([]);
        const [valuteDBOnExpenceDate, setValuteDBOnExpenceDate] = useState([]);
        const [zemljeDB, setZemljeDB] = useState([]);
        const [vozilaNaTuriDB, setVozilaNaTuriDB] = useState([]);
        const [karticeFiltered, setKarticeFiltered] = useState([]);
        const [karticeDB, setKarticeDB] = useState([]);
        const [vrstaTroskaDB, setVrstaTroskaDB] = useState([]);
        const [nacinPlacanjaDB, setNacinPlacanjaDB] = useState([]);
        const [vozaciNaTuriDB, setVozaciNaTuriDB] = useState([]);
        const [tripOld, setTripOld] = useState(null);
        const [izabran, setIzabran] = useState(false)
        const [formVisible, setFormVisible] = useState(false)
        const [suma, setSuma] = useState(null)
        const [putniNalogInfo, setPutniNalogInfo] = useState(null)
                const [selectedRowIdExpence , setSelectedRowIdExpence] = useState(null);
                const isSelected = (row) => String(getIdExpence(row)) === String(selectedRowIdExpence);
        
                const [globalFilter, setGlobalFilter] = useState(null);
                const [first, setFirst] = useState(0);
                const [tableData, setTableData] = useState(null);
                const [allColumns, setAllColumns] = useState([]);
                const [selectedColumns, setSelectedColumns] = useState([]);
                 const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
        const [selectedPrintOption, setSelectedPrintOption] = useState(null);


        const [formSubmitted, setFormSubmitted] = useState(false);
        const getIdExpence = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;

        const getDocumentLocation = (path) => {
            if (!path) return null;
            
            // Normalize Windows path to URL format
            const normalizedPath = path.replace(/\\/g, '/');
            
            // Remove full C:/Dokumenta/ from path
            const relativePath = normalizedPath.replace(/^C:\/Dokumenta\//, '');
            const encodedPath = encodeURI(relativePath); // Encode spaces, etc.
            return `${process.env.REACT_APP_BACKEND_URL}/files/${encodedPath}`;
        };

    ///DATA

    const [formDataExpence, setFormDataExpence] = useState({
        id_vozilo: null,
        datumTroska: null,
        id_zaposleni: null,
        id_vrstaTroska: null,
        id_nacinPlacanja: null,
        id_brojKartice: null,
        id_zemlja: null,
        napomena: '',
        //ispod jedinicnje cene i kurs
        vrednostValuta: null,
        id_valuta: null,
        kurs: null,
        priznatoEur: null,
        //ispod 
        jedinicnaCena: null,
        kolicina: null,
        check_pun: null,
        check_tank: null,
        kilometraza: null,
        //
        stigaoRacun: null
        });
        ///FILES

    const [formDataExpenceFiles, setFormDataExpenceFiles] = useState({
        racunDokument: null
    });

    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

    const handleChangeDocUpload = (name, file) => {
        if (name in formDataExpenceFiles) {
        setFormDataExpenceFiles(prev => ({ ...prev, [name]: file }));
        } 
    };

    const handleChange = async (e) => {
        const { name, value, checked  } = e.target;

        if (name in formDataExpence) {
            if(name == 'check_pun' || name == 'check_tank' || name == 'stigaoRacun') {
                if (name == 'check_pun'){
                    setFormDataExpence(prev => ({ ...prev, [name]: checked }));
                    setFormDataExpence(prev => ({ ...prev, ['check_tank']: false }));
                } else if(name == 'check_tank'){
                    setFormDataExpence(prev => ({ ...prev, [name]: checked }));
                    setFormDataExpence(prev => ({ ...prev, ['check_pun']: false }));
                } else {
                    setFormDataExpence(prev => ({ ...prev, [name]: checked }));    
                }
            } else if(name == 'id_nacinPlacanja') { 
                if(formDataExpence.id_brojKartice)
                    setFormDataExpence(prev => ({ ...prev, ['id_brojKartice']: null }));
                let filtered = karticeDB.filter((x)=> x.tipKartice == value)
                setKarticeFiltered(filtered)
                setFormDataExpence(prev => ({ ...prev, [name]: value }));
            } else if (name == 'vrednostValuta') {
                if(formDataExpence.id_valuta)
                    setFormDataExpence(prev => ({ ...prev, ['id_valuta']: null }));

                if(formDataExpence.kurs)
                    setFormDataExpence(prev => ({ ...prev, ['kurs']: null }));

                if(formDataExpence.priznatoEur)
                    setFormDataExpence(prev => ({ ...prev, ['priznatoEur']: null }));

                setFormDataExpence(prev => ({ ...prev, [name]: value }));
            } else if (name == 'id_valuta') {
                if(formDataExpence.vrednostValuta == null) {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Prvo unesite količinu!",
                        life: 3000,
                    });
                    return
                }

                if(formDataExpence.datumTroska) {
                        const freshValuteDBOnExpenceDate = await getValuteForDate(toUtcIso(formDataExpence.datumTroska))
                        let kursEur = freshValuteDBOnExpenceDate.filter(x=>x.value == 186)
                        if(value){
                            let kurs = freshValuteDBOnExpenceDate.filter(x=>x.value == value)
                            if(value == 186) {
                                setFormDataExpence(prev => ({ ...prev, ['kurs']: 1 }));
                                setFormDataExpence(prev => ({ ...prev, ['priznatoEur']: formDataExpence.vrednostValuta }));
                            } else if (value == 220) {
                                if(kursEur.length > 0) {
                                    setFormDataExpence(prev => ({ ...prev, ['kurs']: kursEur[0].srednji }));
                                    setFormDataExpence(prev => ({ ...prev, ['priznatoEur']:  formDataExpence.vrednostValuta / kursEur[0].srednji }));
                                } else {
                                    toast.current.show({
                                        severity: "warn",
                                        summary: "Upozorenje!",
                                        detail: "Za izabrani datum ne postoji srednji kurs za EUR, unesite ručno!",
                                        life: 3000,
                                    });
                                    return
                                }
                            } else {
                                if(kurs.length == 0) {
                                    toast.current.show({
                                        severity: "warn",
                                        summary: "Upozorenje!",
                                        detail: "Za izabranu valutu za taj datum ne postoji srednji kurs, unesite ručno!",
                                        life: 3000,
                                    });
                                    return
                                } else if(kursEur.length == 0) {
                                    toast.current.show({
                                        severity: "warn",
                                        summary: "Upozorenje!",
                                        detail: "Za izabrani datum ne postoji srednji kurs za EUR, unesite ručno!",
                                        life: 3000,
                                    });
                                    return
                                } else {
                                   // svi NBS srednji kursevi su izraženi u RSD, zato se ide preko RSD: vrednost * srednji(valuta->RSD) / srednji(EUR->RSD)
                                   setFormDataExpence(prev => ({ ...prev, ['priznatoEur']: (formDataExpence.vrednostValuta * kurs[0].srednji) / kursEur[0].srednji }));
                                }
                            }
                            if(formDataExpence.vrednostValuta) {

                            if(kurs.length > 0 && value != 220 && value != 186)
                            setFormDataExpence(prev => ({ ...prev, ['kurs']: kurs[0].srednji }));
                            }
                        setFormDataExpence(prev => ({ ...prev, [name]: value }));
                        } else {
                            setFormDataExpence(prev => ({ ...prev, [name]: null }));
                            setFormDataExpence(prev => ({ ...prev, ['kurs']: null }));
                        }
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Prvo izaberite datum troška!",
                        life: 3000,
                    });
                    return
                }
                

            } else if (name == 'kolicina') {
                let sum;
                if(formDataExpence.jedinicnaCena != null)
                    sum = formDataExpence.jedinicnaCena * value

                if(formDataExpence.id_valuta != null)
                setFormDataExpence(prev => ({ ...prev, ['id_valuta']: null }));

                setFormDataExpence(prev => ({ ...prev, ['vrednostValuta']: sum }));
                setFormDataExpence(prev => ({ ...prev, [name]: value }));
            } else if (name == 'jedinicnaCena') {
                let sum;
                if(formDataExpence.kolicina != null)
                    sum = formDataExpence.kolicina * value

                if(formDataExpence.id_valuta != null)
                setFormDataExpence(prev => ({ ...prev, ['id_valuta']: null }));

                setFormDataExpence(prev => ({ ...prev, ['vrednostValuta']: sum }));
                setFormDataExpence(prev => ({ ...prev, [name]: value }));
            } else if (name == 'datumTroska') {
                getValuteForDate(toUtcIso(value))
                setFormDataExpence(prev => ({ ...prev, [name]: value }));
                if(formDataExpence.id_valuta != null)
                setFormDataExpence(prev => ({ ...prev, ['id_valuta']: null }));
                if(formDataExpence.priznatoEur != null)
                setFormDataExpence(prev => ({ ...prev, ['priznatoEur']: null }));
            } else {
                setFormDataExpence(prev => ({ ...prev, [name]: value }));
            }
        }
    };

    const resetData = ()=> {
        setFormDataExpence({
            id_vozilo: null,
            datumTroska: null,
            id_zaposleni: null,
            id_vrstaTroska: null,
            id_nacinPlacanja: null,
            id_brojKartice: null,
            id_zemlja: null,
            napomena: '',
            vrednostValuta: null,
            id_valuta: null,
            kurs: null,
            priznatoEur: null,
            jedinicnaCena: null,
            kolicina: null,
            check_pun: null,
            check_tank: null,
            kilometraza: null,
            stigaoRacun: null
        });
}

const resetDataFiles=()=>{
     setFormDataExpenceFiles({
        racunDokument: null
    });
}

const getConfigColumns = async () => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth.token,
    },
    body: JSON.stringify({
      id_config: 269
    }),
  };

    const data = await fetch(process.env.REACT_APP_BACKEND_URL + "/config/", requestOptions)
      .then(handleErrors); 

    if (data.message) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: data.message,
        life: 3000,
      });
      return { empty: true, data: [] };
    }

     if(data.length > 0) {
                    return { empty: false, data: data };
                } else {
                    return { empty: true, data: [] };
                }


};


   useEffect(()=>{
    if(trip != tripOld){
        resetData()
        setTripOld(trip)
    }
    if(trip) {
          if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  id: trip
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/trip/GetTypesAndExpences", requestOptions)
                              .then(handleErrors)
                              .then(async (data) => {
                                
                                /* Procedura vraća jedan red sa jednom bezimenom kolonom.
                                   Ako je rezultat prazan, JSON.parse(undefined) baca
                                   grešku koja je ranije nestajala bez traga. */
                                const stringifiedJson = data?.[0]?.[""];
                                if (!stringifiedJson) {
                                    toast.current?.show({
                                        severity: 'warn', summary: 'Upozorenje!',
                                        detail: 'Podaci za unos troška nisu stigli. Izaberi putni nalog pa pokušaj ponovo.',
                                        life: 4000,
                                    });
                                    return;
                                }
                                const parsedData = JSON.parse(stringifiedJson);

                                setSuma(parsedData.SumaTroskaNaTuri)
                                setValutaDB(parsedData.ValuteDB)
                                setZemljeDB(parsedData.ZemljeDB)
                                setVozilaNaTuriDB(parsedData.VozilaNaTuriDB)
                                /* Procedura izostavlja ključ kad nema nijednog reda
                                   (JSON_MODIFY sa NULL vrednošću briše ključ), pa se do
                                   prvog elementa ide oprezno — inače TypeError obori
                                   ceo .then i nijedan dropdown se ne napuni. */
                                if (formDataExpence.id_vozilo == null && parsedData.VozilaNaTuriDB?.[0])
                                    setFormDataExpence(prev => ({ ...prev, ['id_vozilo']: parsedData.VozilaNaTuriDB[0].value }));
                                setKarticeDB(parsedData.KarticeDB)
                                setVrstaTroskaDB(parsedData.VrstaTroskaDB)
                                setNacinPlacanjaDB(parsedData.NacinPlacanjaDB)
                                setVozaciNaTuriDB(parsedData.VozaciNaTuriDB)
                           
                                if (formDataExpence.id_zaposleni == null && parsedData.VozaciNaTuriDB?.[0])
                                    setFormDataExpence(prev => ({ ...prev, ['id_zaposleni']: parsedData.VozaciNaTuriDB[0].value }));
                                setNacinPlacanjaDB(parsedData.NacinPlacanjaDB)

                                setTableData(parsedData.TroskoviNaTuriDB)
                                setPutniNalogInfo(parsedData.PutniNalog?.[0] || null)

                                 if (parsedData.TroskoviNaTuriDB && parsedData.TroskoviNaTuriDB.length > 0) {
                                    const columns = Object.keys(parsedData.TroskoviNaTuriDB[0])
                                        .filter(key => !['ID'].includes(key))
                                        .map(key => ({ label: key, value: key }));

                                    setAllColumns(columns);
                                    const originalOrder = Object.keys(parsedData.TroskoviNaTuriDB[0]);
                                    setOriginalColumnOrder(originalOrder);

                                    const columnsDB = await getConfigColumns();

                                    if (!columnsDB.empty && columnsDB.data.length > 0) {
                                        const arr = JSON.parse(columnsDB.data[0].parametri);
                                        setSelectedColumns(arr);
                                    } else {
                                        setSelectedColumns(columns.slice(0, 5).map(col => col.value));
                                    }
                                    }

                              })
                              .catch(async (error) => {
                                  /* Ranije je ovde stajalo samo error.json(). To radi
                                     kad je greška HTTP odgovor, ali NE i kad je obična
                                     JS greška iz .then bloka: tada error.json ne postoji,
                                     pa i sam .catch pukne. Rezultat je bio potpuno tih
                                     otkaz — dropdowni prazni, nigde ni poruke ni loga.
                                     Zato se sada razdvajaju dva slučaja. */
                                  let poruka = 'Greška pri učitavanju podataka o troškovima.';
                                  if (typeof error?.json === 'function') {
                                      try {
                                          const telo = await error.json();
                                          if (telo?.message) poruka = telo.message;
                                      } catch { /* odgovor nije JSON — ostaje opšta poruka */ }
                                  } else if (error?.message) {
                                      poruka = error.message;
                                  }
                                  console.error('Troskovi — učitavanje nije uspelo:', error);
                                  toast.current?.show({
                                      severity: 'error', summary: 'Greška', detail: poruka, life: 5000,
                                  });
                              });
    }
    } else {
             toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste izabrali putni nalog!",
                          life: 3000,
                      });
    }
  
      },[formSubmitted, trip])

    const getValuteForDate = (date) => {

           let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  date: date
                              }),
                          };
                          return fetch(process.env.REACT_APP_BACKEND_URL + "/finance/GetMiddleCourseForDate", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                setValuteDBOnExpenceDate(data)
                                return data
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              return []
                              });
    }


    const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali trošak da bi popunili podatke!",
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/GetExpence", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                               
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: "Uspešno popunjavanje podataka troška!",
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

  const popuniStavke = (apiData) => {

    setFormDataExpence({
        id_vozilo: apiData[0].id_vozilo || null,
        datumTroska: apiData[0].datumTroska ? new Date(apiData[0].datumTroska) : null,
        id_zaposleni: apiData[0].id_zaposleni || null,
        id_vrstaTroska: apiData[0].id_vrstaTroska || null,
        id_nacinPlacanja: apiData[0].id_nacinPlacanja || null,
        id_brojKartice: apiData[0].id_brojKartice || null,
        id_zemlja: apiData[0].id_zemlja || null,
        napomena: apiData[0].napomena || '',
        vrednostValuta: apiData[0].vrednostValuta || null,
        id_valuta: apiData[0].id_valuta || null,
        kurs: apiData[0].kurs || null,
        priznatoEur: apiData[0].priznatoEur || null,
        jedinicnaCena: apiData[0].jedinicnaCena || null,
        kolicina: apiData[0].kolicina || null,
        check_pun: apiData[0].check_pun || null,
        check_tank: apiData[0].check_tank || null,
        kilometraza: apiData[0].kilometraza || null,
        stigaoRacun: apiData[0].stigaoRacun || null
      });
};




const handleDeleteFuncExpence = () => {
       
            confirmDialog({
            message: "Želite obrisati trošak?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async () => {

 setFormSubmitted(true)

  if (idExpence) {
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idExpence
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/trip/DeleteExpence", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: "Uspešna brisanje troška!",
                life: 3000,
                });
                resetData()
                setFormSubmitted(false)
                setIdExpence(null)
                setSelectedRowIdExpence(null)
                setIzabran(false)
                setFormVisible(false)
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali trošak za brisanje!",
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 
  
  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

    const handleUploadAndSaveFiles = async (id)=> {
              
                                            const formData = new FormData();
                                            formData.append("id", id);
                                            formData.append("entityType", "troskovi");

                                            Object.entries(formDataExpenceFiles).forEach(([key, file]) => {
                                            if (file) formData.append(key, file);
                                            });

                                            let requestOptionsFiles = {
                                                method: "POST",
                                                headers: {
                                                Authorization: "Bearer " + auth.token,
                                                },
                                                body: formData
                                            };
       
                                                await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/InsertExpenceFiles", requestOptionsFiles)
                                                .then(handleErrors)
                                                .then((data) => {
         
                                                    resetDataFiles()
                                                    toast.current.show({
                                                    severity: "success",
                                                    summary: data.message,
                                                    life: 3000,
                                                      });

                                                })
                                                .catch((error) => {
                                                error.json().then((errorMessage) => {
                                                    toast.current.show({
                                                    severity: "error",
                                                    summary: "Error",
                                                    detail: errorMessage[0].message,
                                                    life: 3000,
                                                    });
                                                    console.log(errorMessage);
                                                });
                                            })
                                 
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {
  
              //DATA
                  const hasAnyValueExpence = Object.values(formDataExpence).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  
                  const hasAnyValueExpenceFiles = Object.values(formDataExpenceFiles).some(value => {
                    if (value === null || value === '') return false;
                    if (value instanceof Date && isNaN(value.getTime())) return false;
                    return true;
                    });

                  const payload = {
                        ...formDataExpence,
                        datumTroska: toUtcIso(formDataExpence.datumTroska)
                        };

                  if(izabran && idExpence){
                 if(hasAnyValueExpence){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idExpence),
                                id_putni_nalog: trip,
                                formDataExpence: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/UpdateExpence", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                             
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima troška.' && data[0].message != 'Uspešna izmena!'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima troška.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                               } else {
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka troška!",
                                life: 3000,
                                });
                               
                               }
                               
                                if(selectedRowIdExpence && hasAnyValueExpenceFiles) {
                                handleUploadAndSaveFiles(selectedRowIdExpence)
                                }
                                setFormSubmitted(false)
                                setIdExpence(null)
                                setSelectedRowIdExpence(null)
                                setIzabran(false)
                                resetData() 
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke troška!",
                        life: 3000,
                    });
                }
           
           
                } else {
                  if(hasAnyValueExpence){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  id_putni_nalog: trip,
                                  formDataExpence: payload
                              }),
                          };
                          
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/InsertExpence", requestOptions)
                              .then(handleErrors)
                              .then((data) => {

                                  if(data) {
                                        if(data.message === 'Nedostaju obavezna polja za unos troška.'){
                                        toast.current.show({
                                        severity: "error",
                                        summary: "Error",
                                        detail: data.message,
                                        life: 3000,
                                        });
                                        return
                                        } 
                                  }
                                  resetData()


                                 if(data[0].ID && hasAnyValueExpenceFiles) {
                                    handleUploadAndSaveFiles(data[0].ID)
                                    }
                                  setFormSubmitted(false)
                                 toast.current.show({
                                  severity: "success",
                                  summary: "Uspešan unos podataka troška!",
                                  life: 3000,
                                  });

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste popunili podatke troška za unos!",
                          life: 3000,
                      });
                  }
            }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };     
  

  
  
  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };


  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Troškovi');
  
      const headers = selectedColumns;

      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Troškovi - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
  const printTroskovnik = () => {
      if (!trip) {
          toast.current.show({ severity: 'warn', summary: 'Niste izabrali putni nalog!', life: 3000 });
          return;
      }
      if (selectedPrintOption == null) {
          toast.current.show({ severity: 'warn', summary: 'Izaberite opciju štampe iz liste!', life: 3000 });
          return;
      }
      const isSuma = selectedPrintOption === '__suma__';
      const body = isSuma
          ? { id_putni_nalog: trip, tipStampe: 'suma' }
          : { id_putni_nalog: trip, id_zaposleni: selectedPrintOption };
      fetch(process.env.REACT_APP_BACKEND_URL + '/trip/PrintTroskovnik', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
          body: JSON.stringify(body)
      })
          .then(r => r.json())
          .then(data => {
              if (data.message) {
                  toast.current.show({ severity: 'error', summary: data.message, life: 5000 });
                  return;
              }
              handlePrintInvoice(data);
          })
          .catch(() => toast.current.show({ severity: 'error', summary: 'Greška pri generisanju troskovnika.', life: 4000 }));
  };

      const printOptions = [
          ...(vozaciNaTuriDB || []).map(v => ({ label: `Troskovnik - ${v.label}`, value: v.value })),
          { label: 'Suma troškova na turi', value: '__suma__' }
      ];

      const openNewExpence = () => {
          setSelectedRowIdExpence(null)
          setIdExpence(null)
          resetData()
          setIzabran(false)
          setFormVisible(true)
      }

      const closeFormDialog = () => {
          setFormVisible(false)
          setSelectedRowIdExpence(null)
          setIdExpence(null)
          resetData()
          setIzabran(false)
      }

      /* Trošak koji je vozač uneo sa telefona (izvorUnosa = 'MOBILNI') stoji kao
         "Čeka potvrdu" dok ga operater ne prihvati. Operater ga pre toga može i izmeniti
         kroz istu formu — potvrda je odvojena akcija, da izmena ne bi značila i odobrenje. */
      const izabranRed = (tableData || []).find(r => String(getIdExpence(r)) === String(selectedRowIdExpence));
      const cekaPotvrdu = !!izabranRed && izabranRed.izvorUnosa === 'MOBILNI' && !Number(izabranRed.jePotvrdjen);
      const jePotvrdjenIzabran = !!izabranRed && izabranRed.izvorUnosa === 'MOBILNI' && !!Number(izabranRed.jePotvrdjen);

      const potvrdiTrosak = (potvrdi) => {
          if (!selectedRowIdExpence) return;
          setFormSubmitted(true);
          fetch(process.env.REACT_APP_BACKEND_URL + "/trip/PotvrdiTrosak", {
              method: "POST",
              headers: { "Content-Type": "application/json", Authorization: "Bearer " + auth.token },
              body: JSON.stringify({ id: selectedRowIdExpence, potvrdi }),
          })
              .then(handleErrors)
              .then((data) => {
                  toast.current.show({
                      severity: "success",
                      summary: data?.message || (potvrdi ? t('ture.trosakPrihvacen') : t('ture.potvrdaPovucena')),
                      life: 3000,
                  });
                  setFormSubmitted(false); // retriguje učitavanje tabele (isti obrazac kao brisanje)
              })
              .catch((error) => {
                  setFormSubmitted(false);
                  error.json?.().then((errorMessage) => {
                      toast.current.show({ severity: "error", summary: "Error", detail: errorMessage.message, life: 3000 });
                  });
              });
      };

      /* Troškovi koje su vozači poslali sa telefona (trip.VozacTrosak) — nisu
         troškovi ture dok ih operater ne prihvati, pa se i ne vide u tabeli
         ispod. Značka na dugmetu visi dok ima nerešenih. Lista dolazi iz
         obracunTure, da bi ista značka stajala i na samom tabu. */
      const [vozacDialog, setVozacDialog] = useState(false);
      const vozacVisi = (vozacTroskovi || []).filter(r => Number(r.statusObrade) === 0).length;

      /* Prihvatanje upisuje nov red u troškovnik, pa se mora osvežiti i tabela
         stvarnih troškova — isti obrazac kao posle brisanja (`formSubmitted`
         retriguje učitavanje).

         Dva koraka, ne jedan: React sabija dve izmene istog stanja u ISTOM tiku
         u jedan render, pa bi `true` → `false` zajedno prošlo kao da se ništa
         nije promenilo i efekat se ne bi ponovio — tabela bi ostala stara. */
      const vozacPromena = () => {
          osveziVozacTroskove?.();
          setFormSubmitted(true);
          setTimeout(() => setFormSubmitted(false), 0);
      };

       const header = (
         <div className="export-buttons fakture-stavke-header fakture-header-zbir">
          <div className="fakture-stavke-radnje" style={{display: 'flex', alignItems: 'center'}}>
              <Button type="button" icon="pi pi-plus" severity="info" onClick={openNewExpence} data-pr-tooltip="Novi trošak" style={{marginRight:'1%'}}/>
              <Button type="button" icon="pi pi-mobile" severity={vozacVisi > 0 ? 'warning' : 'secondary'}
                      label={t('saTelefona.troskoviDugme')} onClick={() => setVozacDialog(true)}
                      data-pr-tooltip={vozacVisi > 0 ? t('saTelefona.visiTooltip') : t('saTelefona.troskoviNaslov')}
                      style={{marginRight:'1%'}}>
                  {vozacVisi > 0 && <Badge value={vozacVisi} severity="danger" className="ml-2" />}
              </Button>
              {cekaPotvrdu && (
                  <Button type="button" icon="pi pi-check" severity="success" label={t('ture.prihvati')}
                          onClick={() => potvrdiTrosak(true)} style={{marginRight:'1%'}}/>
              )}
              {jePotvrdjenIzabran && (
                  <Button type="button" icon="pi pi-undo" severity="warning" label={t('ture.povuciPotvrdu')}
                          onClick={() => potvrdiTrosak(false)} style={{marginRight:'1%'}}/>
              )}
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" style={{marginRight:'1%'}}/>
              <CustomDropdown
                  value={selectedPrintOption}
                  options={printOptions}
                  optionLabel="label"
                  placeholder={t('ture.phStampu')}
                  onChange={(e) => setSelectedPrintOption(e.target.value)}
                  style={{marginRight:'0.5rem', minWidth:'220px'}}
              />
              <Button type="button" icon="pi pi-print" severity="secondary" onClick={printTroskovnik} style={{marginRight:'1%'}}/>
          </div>
          <div className="fakture-stavke-zbir">{t('ture.ukupnoNaTuri')}: {suma && suma[0].Suma > 0 ? suma[0].Suma + ' €' : '0 €'}</div>
          <input
              type="search"
              onInput={(e) => setGlobalFilter(e.target.value)}
              placeholder={t('nova.phPretraga')}
              className="p-inputtext p-component"
          />
        </div>
      );
      
     const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument') ||  // Generic document
           field.includes('dokument');// Generic document
  };

    const chooseExpence = (rowData) => {
        const id = getIdExpence(rowData);

        setSelectedRowIdExpence((prev) => {
        const next = String(prev) === String(id) ? null : String(id);

        if(next) {
        setIdExpence(next)
        popuniRedove(id)
        setIzabran(true)
        setFormVisible(true)
        }
        else {
        setIdExpence(null)
        resetData()
        setIzabran(false)
        setFormVisible(false)
        }

        return next;
    });
    }

     const previewBodyTemplateWork = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
    if(field == 'Izaberi') { 
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseExpence(rowData)}
              />
            
        </div>
      );
      } else {
         const filePaths = filePathsString.split('|').filter(p => p.trim() !== '');
       
         return (
           <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
             {filePaths.map((path, idx) => {
               const documentUrl = getDocumentLocation(path);
               if (!documentUrl) return null;
       
               // Izdvoji ime fajla bez ekstenzije
               const fileNameWithExt = path.split('/').pop(); // npr. TOI-Psihologija-2016-testkljuc_20250726222909703.pdf
               const fileName = fileNameWithExt.replace(/\.(pdf|jpg|png)$/i, '');
       
               return (
                 <Button
                   key={idx}
                   label={fileName}
                   icon="pi pi-eye"
                   className="p-button-text p-button-sm"
                   onClick={() => window.open(documentUrl, '_blank')}
                   tooltip="Pregledaj dokument"
                   tooltipOptions={{ position: 'top' }}
                 />
               );
             })}
           </div>
         );
         }  
    }; 

      const handleSaveConfig = () => {
             confirmDialog({
                        message: "Jel ste sigurni da želite sačuvati konfiguraciju?",
                        acceptLabel: "Da",
                        rejectLabel: "Ne",
                        icon: "pi pi-info-circle",
                        acceptClassName: "p-button-danger",
                        accept: acceptInsertConfig,
                        reject: rejectInsertConfig,
                        });
      }
    
      const acceptInsertConfig  = () => {
       if(selectedColumns.length > 0) {
          let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id_config: 269,
            parametri: selectedColumns
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/config/changeConfig", requestOptions)
          .then(handleErrors)
          .then((data) => {
    
                if(data.message && data.message == 'Nema izmena u podacima konfiguracije pregleda.'){
                    toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: data.message,
                        life: 3000,
                        });
                    return
                    }  
      
                toast.current.show({
                    severity: "success",
                    summary: "Uspešna izmena konfiguracije pregleda za Troškove!",
                    life: 3000,
                });
    
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          }); 
        } else {
            toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Morate imati barem 1 izabranu stavku!",
                        life: 3000,
                        });
        }
      }
      const rejectInsertConfig = () => {
        console.log('Config insert rejected!')
      }

   return (
       <div style={{marginTop:"1%"}}>
        <Toast ref={toast} />
        <VozacTroskoviDialog visible={vozacDialog} onHide={() => setVozacDialog(false)}
                             unosi={vozacTroskovi} onPromena={vozacPromena} />

            <div className='col-12' style={{padding: 0}}>
                          <div className='blagajnaDashboard' style={{display:'flex', gap:'1rem', alignItems:'flex-start', flexWrap:'wrap'}}>
                             <Dialog
                                visible={formVisible}
                                onHide={closeFormDialog}
                                header={
                                    <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', width:'100%', paddingRight:'2rem'}}>
                                        <span>{izabran ? "Izmena troška" : "Unos troška"}</span>
                                        {izabran && (
                                            <Button type="button" icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFuncExpence} tooltip="Obriši trošak" tooltipOptions={{position:'bottom'}} />
                                        )}
                                    </div>
                                }
                                style={{width:'95vw', maxWidth:'900px'}}
                                modal>
                             <div id="troskovi_unos">
                            <form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                            <div className="gridLicni" style={{marginBottom:'1%'}}>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="id_vozilo">{t('ture.voziloDuzi')}:</label>
                                            <CustomDropdown
                                                 id="id_vozilo" 
                                                 name="id_vozilo" 
                                                 value={formDataExpence.id_vozilo} 
                                                 required
                                                invalid={invalidControl(formDataExpence.id_vozilo)}
                                                 options={vozilaNaTuriDB || []}
                                                 placeholder={t('nova.phVozilo')}
                                                 optionLabel="label"
                                                 onChange={handleChange} />
                              </div>
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="datumTroska">{t('ture.datumTroska')}:</label>
                                            <Calendar 
                                                id="datumTroska"
                                                name="datumTroska"
                                                required
                                                invalid={invalidControl(formDataExpence.datumTroska)}
                                                value={formDataExpence.datumTroska} 
                                                onChange={handleChange}
                                                showIcon 
                                                dateFormat="dd.mm.yy" 
                                                mask="99.99.9999"
                                                />
                              </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="id_zaposleni">{t('ture.vozaci')}:</label>
                                            <CustomDropdown
                                                 id="id_zaposleni" 
                                                 name="id_zaposleni" 
                                                 required
                                                invalid={invalidControl(formDataExpence.id_zaposleni)}
                                                 value={formDataExpence.id_zaposleni} 
                                                 options={vozaciNaTuriDB || []}
                                                 placeholder={t('ture.phVozaca')}
                                                 optionLabel="label"
                                                 onChange={handleChange} />
                              </div>
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="id_vrstaTroska">{t('ture.vrstaTroska')}:</label>
                                          <CustomDropdown 
                                                id="id_vrstaTroska" 
                                                name="id_vrstaTroska" 
                                                required
                                                invalid={invalidControl(formDataExpence.id_vrstaTroska)}
                                                value={formDataExpence.id_vrstaTroska} 
                                                options={vrstaTroskaDB || []} 
                                                optionLabel="label"
                                                onChange={handleChange}
                                                placeholder={t('ture.phTrosak')}
                                            />
                              </div>
                                 <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="id_nacinPlacanja">{t('ture.nacinPlacanja')}:</label>
                                          <CustomDropdown 
                                                id="id_nacinPlacanja" 
                                                name="id_nacinPlacanja" 
                                                required
                                                invalid={invalidControl(formDataExpence.id_nacinPlacanja)}
                                                value={formDataExpence.id_nacinPlacanja} 
                                                options={nacinPlacanjaDB || []} 
                                                optionLabel="label"
                                                onChange={handleChange}
                                                placeholder={t('ture.phPlacanje')}
                                            />
                              </div>

                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                    <label htmlFor="id_brojKartice">{t('ture.brojKartice')}:</label>
                                      <CustomDropdown 
                                                id="id_brojKartice" 
                                                name="id_brojKartice" 
                                                value={formDataExpence.id_brojKartice} 
                                                options={karticeFiltered || []} 
                                                optionLabel="label"
                                                onChange={handleChange}
                                                placeholder={t('ture.phKarticu')}
                                            />
                                </div>
                              
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="id_zemlja">{t('ture.drzava')}:</label>
                                            <CustomDropdown 
                                                id="id_zemlja" 
                                                name="id_zemlja" 
                                                required
                                                invalid={invalidControl(formDataExpence.id_zemlja)}
                                                value={formDataExpence.id_zemlja} 
                                                options={zemljeDB || []} 
                                                optionLabel="label"
                                                onChange={handleChange}
                                                placeholder={t('ture.phZemlju')}
                                            />
                              </div>
                              <div className="col-12 md:col-6">
                                                                  <label htmlFor="racunDokument">{t('ture.racunSlika')}:</label>
                                                                  {!formDataExpenceFiles.racunDokument ? 
                                                                      <FileUpload
                                                                          name="racunDokument"
                                                                          chooseLabel="Izaberi"
                                                                          uploadLabel="Pošalji"
                                                                          mode="basic"
                                                                          accept=".pdf,.jpg,.png"
                                                                          maxFileSize={5000000}
                                                                          onSelect={(e) => handleChangeDocUpload("racunDokument", e.files[0])}
                                                                      /> : 
                                                                      <Button 
                                                                          label={formDataExpenceFiles.racunDokument.name} 
                                                                          onClick={() => handleChangeDocUpload("racunDokument", null)} 
                                                                      />
                                                                  }
                                                              </div>
                              <div className="col-12 md:col-6 maxWidthInput" style={{display: 'flex', flexDirection:'column',flex: '0 0 100%', maxWidth: '100%'}}>
                                <label htmlFor="pin">{t('nova.napomena')}:</label>
                                            <InputTextarea 
                                                id="napomena"
                                                name="napomena"
                                                value={formDataExpence.napomena}
                                                onChange={handleChange}
                                                />
                              </div>

                            </div>
                            <div className="gridLicni gridTroskovi" style={{paddingTop:"1%", paddingBottom:"1%",borderTop: '1px solid rgb(209 208 208)'}}>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column',flex: '0 0 19%', maxWidth: '19%'}}>
                                    <label htmlFor="jedinicnaCena">{t('nova.jedinicnaCena')}:</label>
                                        <InputNumber
                                        id="jedinicnaCena"
                                        required
                                        invalid={invalidControl(formDataExpence.jedinicnaCena)}
                                        mode="decimal"
                                        minFractionDigits={3}
                                        maxFractionDigits={3}
                                        name="jedinicnaCena"
                                        disabled={!(formDataExpence.id_vrstaTroska == 223 || formDataExpence.id_vrstaTroska == 224)}
                                        value={formDataExpence.jedinicnaCena}
                                        onValueChange={handleChange}
                                        />
                                </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column',flex: '0 0 19%', maxWidth: '19%'}}>
                                    <label htmlFor="kolicina">{t('nova.kolicina')}:</label>
                                        <InputNumber
                                        id="kolicina"
                                        required={formDataExpence.jedinicnaCena != null ? true : false}
                                        invalid={formDataExpence.jedinicnaCena != null ? invalidControl(formDataExpence.kolicina) : null}
                                        mode="decimal"
                                        minFractionDigits={2}
                                        maxFractionDigits={2}
                                        name="kolicina"
                                        disabled={!(formDataExpence.id_vrstaTroska == 223 || formDataExpence.id_vrstaTroska == 224)}
                                        value={formDataExpence.kolicina}
                                        onValueChange={handleChange}
                                        />
                                </div>
                                 <div className="col-12 md:col-6" style={{maxWidth:"30px"}}>
                                    <label htmlFor="check_pun">{t('ture.pun')}:</label>
                                    <Checkbox 
                                    id="check_pun"
                                    required={formDataExpence.jedinicnaCena != null && !formDataExpence.check_tank ? true : false} 
                                    invalid={formDataExpence.jedinicnaCena != null ? invalidControl(formDataExpence.check_pun) : null}
                                    name="check_pun" 
                                    checked={formDataExpence.check_pun} 
                                    disabled={!(formDataExpence.id_vrstaTroska == 223 || formDataExpence.id_vrstaTroska == 224)}
                                    onChange={handleChange} 
                                    />
                                </div>
                                <div className="col-12 md:col-6" style={{maxWidth:"30px"}}>
                                    <label htmlFor="check_tank">{t('ture.tank')}:</label>
                                    <Checkbox 
                                    required={formDataExpence.jedinicnaCena != null && !formDataExpence.check_pun ? true : false}
                                    invalid={formDataExpence.jedinicnaCena != null ? invalidControl(formDataExpence.check_tank) : null}
                                    id="check_tank" 
                                    name="check_tank" 
                                    checked={formDataExpence.check_tank} 
                                    disabled={!(formDataExpence.id_vrstaTroska == 223 || formDataExpence.id_vrstaTroska == 224)}
                                    onChange={handleChange} 
                                    />
                                </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column',flex: '0 0 19%', maxWidth: '19%'}}>
                                    <label htmlFor="kilometraza">{t('ture.kilometraza')}:</label>
                                    <InputNumber 
                                        id="kilometraza" 
                                        name="kilometraza"  
                                        required={formDataExpence.jedinicnaCena != null ? true : false}
                                        mode="decimal"
                                        minFractionDigits={2}
                                        maxFractionDigits={2} 
                                        invalid={formDataExpence.jedinicnaCena != null ? invalidControl(formDataExpence.kilometraza) : null} 
                                        disabled={!(formDataExpence.id_vrstaTroska == 223 || formDataExpence.id_vrstaTroska == 224)}
                                        value={formDataExpence.kilometraza} 
                                        onValueChange={handleChange} 
                                        />
                                </div>
                               
                            </div>
                             <div className="gridLicni gridTroskovi" style={{paddingTop:"1%", borderTop: '1px solid rgb(209 208 208)'}}>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column',flex: '0 0 19%', maxWidth: '19%'}}>
                                    <label htmlFor="vrednostValuta">{t('ture.vrednostValuti')}:</label>
                                        <InputNumber
                                        id="vrednostValuta"
                                        required
                                        invalid={invalidControl(formDataExpence.vrednostValuta)}
                                        mode="decimal"
                                        minFractionDigits={2}
                                        maxFractionDigits={2}
                                        name="vrednostValuta"
                                        value={formDataExpence.vrednostValuta}
                                        onValueChange={handleChange}
                                        />
                                </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column',flex: '0 0 19%', maxWidth: '19%'}}>
                                    <label htmlFor="id_valuta">{t('nova.valuta')}:</label>
                                            <CustomDropdown 
                                                id="id_valuta" 
                                                name="id_valuta" 
                                                required
                                                invalid={invalidControl(formDataExpence.id_valuta)}
                                                value={formDataExpence.id_valuta} 
                                                options={valuteDB || []} 
                                                optionLabel="label"
                                                onChange={handleChange}
                                                placeholder={t('nova.phValutu')}
                                            />
                                </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column',flex: '0 0 19%', maxWidth: '19%'}}>
                                    <label htmlFor="kurs">{t('nova.kurs')}:</label>
                                    <InputNumber 
                                        id="kurs" 
                                        name="kurs"  
                                        required
                                        mode="decimal"
                                        minFractionDigits={4}
                                        maxFractionDigits={4} 
                                        invalid={invalidControl(formDataExpence.kurs)}
                                        value={formDataExpence.kurs} 
                                        onValueChange={handleChange} 
                                        />
                                </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column',flex: '0 0 19%', maxWidth: '19%'}}>
                                    <label htmlFor="priznatoEur">{t('ture.priznatoEur')}:</label>
                                        <InputNumber
                                        id="priznatoEur"
                                        required
                                        invalid={invalidControl(formDataExpence.priznatoEur)}
                                        mode="decimal"
                                        minFractionDigits={2}
                                        maxFractionDigits={2}
                                        name="priznatoEur"
                                        value={formDataExpence.priznatoEur}
                                        onValueChange={handleChange}
                                        />
                                </div>
                                 <div className="col-12 md:col-6" style={{maxWidth:"fit-content", padding:'1%', border:'1px solid rgb(209 208 208)', display:'flex', flexDirection: 'column',
                                    justifyContent: 'center', alignItems: 'center', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)'}}>
                                    <label htmlFor="stigaoRacun">{t('ture.stigaoRacun')}:</label>
                                    <Checkbox 
                                    id="stigaoRacun"
                                    name="stigaoRacun" 
                                    checked={formDataExpence.stigaoRacun} 
                                    onChange={handleChange} 
                                    />
                                </div>

                               
                            </div>
                            <div className="formUnosZap buttonUnosZap">
                            <button type="submit" onClick={handleFormSubmit} style={{minWidth:"fit-content", marginTop:'2%'}} className="btn btn-success">
                                {izabran ? "SAČUVAJ" : "UNOS"}
                            </button>
                            </div>
                            </form>
                             </div>
                             </Dialog>
                             <div style={{flex:'1 1 100%', minWidth:'300px'}}>
                          <Card>
                               <Tooltip target=".export-buttons>button" position="bottom" />
                                     <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1em"}}>
                                       <div style={{ width: "20%" }}>
                                         {allColumns.length > 0 && (
                                           <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}><MultiSelect
                                             value={selectedColumns}
                                             options={allColumns}
                                             onChange={(e) => {
                                 const sorted = originalColumnOrder.filter((key) => e.value.includes(key));
                                 setSelectedColumns(sorted);
                               }}
                                             optionLabel="label"
                                             display="chip"
                                             placeholder={t('nova.odaberiteKolone')}
                                             style={{ width: '100%' }}
                                             showSelectAll={true}
                                             filter
                                             filterPlaceholder="Pretraži kolone"
                                             maxSelectedLabels={3}
                                             selectedItemsLabel="{0} kolona odabrano"
                                           />
                                           <button onClick={handleSaveConfig} style={{marginLeft:'1%'}} className="configSaveButton"><i className="pi pi-save"></i></button></div>
                                         )}
                                       </div>
                                     </div>
                                   <DataTable
                                          value={tableData || []}
                                          paginator
                                          rows={10}
                                          first={first}
                                          globalFilter={globalFilter}
                                          onPage={(e) => setFirst(e.first)}
                                          scrollable
                                          header={header}
                                          scrollHeight="50vh"
                                          emptyMessage={t('common.noDataTable')}
                                          resizableColumns
                                          className="turePregledTable stavke-tabela"
                                          columnResizeMode="expand"
                                          rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                        >
                                          {selectedColumns.map((colKey) => {
                                          const colMeta = allColumns.find(col => col.value === colKey);
                                          return (
                                            <Column
                                              key={colKey}
                                              field={colKey}
                                              header={colMeta?.label || colKey}
                                              sortable
                                              body={(rowData) => {
                                                if (isButtonColumn(colKey)) {
                                                  return previewBodyTemplateWork(rowData, colKey);
                                                }
                                                return rowData[colKey] || '-';
                                              }}
                                              style={{ minWidth: '150px'}}
                                            />
                                          );
                                        })}
                                    </DataTable>
                          </Card>
                             </div>
                          </div>
            </div>

       </div>
)
}
export default Troskovi;